import { fromPaise } from '@/utils/money';

/** The instalments the counter actually takes. 100% is "the whole thing", so it is last. */
export const AMOUNT_SLABS = [10, 20, 40, 60, 100] as const;

/**
 * Rounds to the nearest rupee: the counter deals in whole rupees, and 10% of ₹5,555 is more
 * useful as ₹556 than ₹555.50. 100% is the exact base instead, so "pay in full" can never land
 * a rupee short and leave a bill that still looks unpaid.
 */
export function slabAmount(basePaise: number, percent: number): string {
  if (percent === 100) return fromPaise(basePaise);
  return fromPaise(Math.round((basePaise * percent) / 100 / 100) * 100);
}
